<template lang='pug'>
  div
    v-tooltip(bottom)
      template(v-slot:activator='{on}')
        v-btn.ma-0(v-on='on' text icon @click.stop.prevent='open=!open')
          v-icon play_arrow
      span Start Load Test
    v-dialog(v-model='open' max-width='400px')
      v-card
        v-card-title
          v-row(no-gutters)
            v-col
              .text-h5.primary--text.text--lighten-2 Start Load Test
        v-card-text
          | Are you sure you want to start this load test with the following details?
          ul
            li Total Concurrent Users:&nbsp;
              strong {{total}}
            li Base URL:&nbsp;
              strong {{loadTest.baseUrl}}
            li Minimum cost:&nbsp;
              strong ${{minCost}}
        v-card-actions
          v-spacer
          v-btn(text @click.native='open=false') Cancel
          v-btn(text type='submit' color='primary' :loading='starting' @click='start') Start
</template>

<script>
import {sumBy} from 'lodash';
import Notifications from '@/services/notification.service';
import LoadTest from '@/api/loadTest';
import UtilMixin from '@/mixins/util.mixin';

export default {
  name: 'BionicMetricsLoadTestRunButton',
  mixins: [UtilMixin],
  props: {
    loadTest: {
      type: Object,
      required: true
    }
  },
  computed: {
    total() {
      return sumBy(this.loadTest.tests, 'count');
    },
    minCost() {
      return this.total * 5 * 0.02;
    }
  },
  methods: {
    async start() {
      try {
        this.starting = true;
        const runGuid = await LoadTest.run(this.loadTest.guid);
        await this.to(`/load-test/${this.loadTest.guid}/results/${runGuid}`);
      } catch (error) {
        Notifications.alert('There was a problem starting the load test. Please check console for details.');
        console.error(error);
      } finally {
        this.starting = false;
      }
    }
  },
  data() {
    return {
      open: false,
      starting: false
    };
  }
};
</script>

<style scoped>

</style>
